<template>
  <ModalFilterTable v-if="modalShowFilterTable" @closeModal="closeModal" />
  <IndexView />
  <div
    id="overlay"
    class="fixed inset-0 bg-black bg-opacity-30 z-30"
    :class="{ hidden: !isBlur }"
  ></div>
  <section class="p-6">
    <PageTitle title="Choose Table" />
    <div class="bg-white w-full rounded-lg py-6 px-5 shadow-lg">
      <SearchBox placeholder="Cari sesuatu..." />
      <FilterLane :items="status" @setCurrentItem="setCurrentItem" />
      <SelectOptions
        v-model="selectedMarketingId"
        label="Marketing"
        id="pilih-marketing"
        :options="allMarketings"
        placeholder="Pilih marketing"
        required="true"
      />
    </div>
    <div class="bg-white w-full rounded-lg py-6 px-5 shadow-lg">
      <div class="mb-5 flex justify-between">
        <AddButton
          to_url="#"
          button_text="Filter"
          button_class="text-base py-2 font-medium"
          @click="showModal"
        />
      </div>
      <div class="overflow-x-auto">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden shadow-lg rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-color-1">
                <tr>
                  <th
                    scope="col"
                    class="p-3 border-b text-color-4 text-left whitespace-nowrap"
                  >
                    No
                  </th>
                  <th
                    scope="col"
                    class="p-3 border-b text-color-4 text-left whitespace-nowrap"
                  >
                    Table
                  </th>
                  <th
                    scope="col"
                    class="p-3 border-b text-color-4 text-left whitespace-nowrap"
                  >
                    Kapasitas
                  </th>
                  <th
                    scope="col"
                    class="p-3 border-b text-color-4 text-left whitespace-nowrap"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    class="p-3 border-b text-color-4 text-left whitespace-nowrap"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-if="listTables.length == 0">
                  <td colspan="12" class="p-3 text-center italic text-gray-400">
                    Belum ada data
                  </td>
                </tr>
                <tr
                  v-else
                  v-for="(table, index) in filteredTables"
                  :key="table.id"
                  :class="{ 'bg-blue-50': index % 2 == 1 }"
                  class="hover:bg-blue-100"
                >
                  <td class="p-3 whitespace-nowrap">{{ index + 1 }}</td>
                  <td class="p-3 whitespace-nowrap">
                    {{ table.name }}
                    <span class="text-green-500">
                      <CheckCircleIcon v-if="table.choose" class="h-5 w-5" />
                    </span>
                  </td>
                  <td class="p-3 whitespace-nowrap">{{ table.capacity }}</td>
                  <td class="p-3 whitespace-nowrap">
                    <span
                      :class="spanStatus[table.status]"
                      class="px-2 py-1 rounded-full text-sm font-medium"
                      >{{ table.status.toUpperCase() }}</span
                    >
                  </td>
                  <td class="p-3 whitespace-nowrap text-gray-500 flex">
                    <button
                      v-if="
                        !isChoosen &&
                        !table.choose &&
                        canReserve.includes(table.status)
                      "
                      :id="'edit-data-' + table.id"
                      class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group"
                    >
                      <BookmarkIcon
                        class="h-4 w-4 group-hover:text-green-700"
                        @click="chooseTable(table)"
                      />
                    </button>
                    <button
                      v-if="table.id == this.selectedTableId"
                      :id="'remove-data-' + table.id"
                      class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group"
                    >
                      <TrashIcon
                        class="h-4 w-4 group-hover:text-green-700"
                        @click="cancelTable(table)"
                      />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="flex items-center justify-center space-x-2 mt-6">
          <button
            class="px-3 py-1 bg-gray-200 text-gray-600 rounded hover:bg-gray-300 transition"
            disabled
          >
            Previous
          </button>
          <button
            class="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            1
          </button>
          <button
            class="px-3 py-1 bg-gray-200 text-gray-600 rounded hover:bg-gray-300 transition"
          >
            2
          </button>
          <button
            class="px-3 py-1 bg-gray-200 text-gray-600 rounded hover:bg-gray-300 transition"
          >
            3
          </button>
          <button
            class="px-3 py-1 bg-gray-200 text-gray-600 rounded hover:bg-gray-300 transition"
          >
            Next
          </button>
        </div>
      </div>
      <button
        class="w-full mt-5 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
        @click="
          next(
            this.selectedTableId,
            this.query.customerName,
            this.selectedMarketingId,
            this.query.orderType
          )
        "
      >
        Reserve
      </button>
    </div>
  </section>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import ModalFilterTable from "@/views/pages/new-transaction/choose-table/ModalFilterTable.vue";
import {
  BookmarkIcon,
  CheckCircleIcon,
  TrashIcon,
} from "@heroicons/vue/24/solid";
import SelectOptions from "@/components/form/SelectOptions.vue";
import SearchBox from "../SearchBox.vue";
import FilterLane from "../FilterLane.vue";
import { mapActions, mapGetters } from "vuex";
import io from "socket.io-client";
export default {
  name: "ChooseTableView",
  components: {
    IndexView,
    PageTitle,
    AddButton,
    ModalFilterTable,
    BookmarkIcon,
    SelectOptions,
    TrashIcon,
    CheckCircleIcon,
    SearchBox,
    FilterLane,
  },
  props: {
    choose: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("marketings", ["allMarketings"]),
    ...mapGetters("tables", ["allTables"]),
    ...mapGetters("cash_registers", ["allCashRegisters"]),
    filteredTables() {
      // Filter item berdasarkan kategori yang dipilih
      if (this.selectedStatus) {
        return this.allTables.filter(
          (item) => item.status == this.selectedStatus
        );
      }
      return this.allTables;
    },
    query() {
      return this.$route.query;
    },
    relevantCashRegister() {
      return this.allCashRegisters.find((cr) => cr.status == "open");
    },
  },
  data() {
    return {
      modalShowFilterTable: false,
      isBlur: false,
      isChoosen: false,
      canReserve: ["available", "ready"],
      transactionType: [
        {
          id: 1,
          name: "Dine In",
          need_table: true,
          close_bill: false,
        },
        {
          id: 2,
          name: "Take Away",
          need_table: false,
          close_bill: false,
        },
        {
          id: 3,
          name: "Delivery",
          need_table: false,
          close_bill: true,
        },
      ],
      status: ["available", "unavailable", "maintenance"],
      spanStatus: {
        available: "bg-yellow-100 text-yellow-800",
        ready: "bg-green-100 text-green-800",
        reserved: "bg-blue-100 text-blue-800",
        not_ordered: "bg-gray-100 text-gray-800",
        maintenance: "bg-red-100 text-red-800",
      },
      listTables: [],
      selectedMarketing: null,
      selectedStatus: null,
      selectedTableId: null,

      isConnected: false,
      isLoading: false,
      socket: null,
      message: "",
      messages: [],
    };
  },
  created() {
    this.$store.dispatch("marketings/fetchMarketings", { limit: 100 });
    this.$store.dispatch("tables/fetchTables", { limit: 100 });
    this.$store.dispatch("cash_registers/fetchCashRegisters");

    this.choose === "true" ? "" : this.$router.push({ name: "newTransaction" });
    this.listTables = [
      {
        id: 1,
        name: "Meja 1",
        capacity: 2,
        status: this.status[Math.floor(Math.random() * this.status.length)],
        choose: false,
      },
      {
        id: 2,
        name: "Meja 2",
        capacity: 4,
        status: this.status[Math.floor(Math.random() * this.status.length)],
        choose: false,
      },
      {
        id: 3,
        name: "Meja 3",
        capacity: 6,
        status: this.status[Math.floor(Math.random() * this.status.length)],
        choose: false,
      },
      {
        id: 4,
        name: "Meja 4",
        capacity: 8,
        status: this.status[Math.floor(Math.random() * this.status.length)],
        choose: false,
      },
      {
        id: 5,
        name: "Meja 5",
        capacity: 10,
        status: this.status[Math.floor(Math.random() * this.status.length)],
        choose: false,
      },
    ];

    this.connectWebSocket();
  },
  beforeUnmount() {
    try {
      if (this.socket) {
        // Remove all listeners to prevent memory leaks
        this.socket.removeAllListeners();
        this.socket.disconnect();
        this.socket = null;
      }
      this.isConnected = false;
      this.listTables = [];
      this.messages = [];
    } catch (error) {
      console.error("Error during cleanup:", error);
    }
  },
  methods: {
    ...mapActions("sales_orders", ["createSalesOrder"]),
    ...mapActions("tables", ["updateTable"]),

    showModal() {
      this.modalShowFilterTable = true;
      this.isBlur = true;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowFilterTable = false;
        this.isBlur = false;
      }, 200);
    },
    chooseTable(table) {
      this.isChoosen = true;
      this.selectedTableId = table.id;
      // for (let index = 0; index < this.listTables.length; index++) {
      //   if (this.listTables[index].id == table.id) {
      //     this.listTables[index].choose = true;
      //   }
      // }
    },
    cancelTable() {
      this.isChoosen = false;
      this.selectedTableId = null;
      // for (let index = 0; index < this.listTables.length; index++) {
      //   if (this.listTables[index].id == table.id) {
      //     this.listTables[index].choose = false;
      //   }
      // }
    },
    setCurrentItem(item) {
      this.selectedStatus = item;
    },
    async next(tableId, customerName, marketingId, orderType) {
      const response = await this.createSalesOrder({
        table_id: tableId,
        marketing_id: marketingId,
        payment_method_id: null,
        cash_register_id: this.relevantCashRegister.id,
        // transaction_type_id: routeQuery.transactionTypeId,
        transaction_type_id: null,
        customer_name: customerName,
        customer_phone: "",
        sub_total: 0,
        grand_total: 0,
        status: "pending", // DataTypes.ENUM("pending", "paid", "canceled")
        order_type: orderType, // DataTypes.ENUM("dine_in", "take_away", "delivery")
        payment_amount: 0,
        payment_change: 0,
        tax: 0,
        service_charge: 0,
        discount: 0,
        note: "",
      });
      const orderId = response.data.id;

      await this.updateTable({ id: tableId, status: "unavailable" });

      // this.isBlur = false;
      this.$router.push({
        name: "order",
        query: {
          tableId,
          customerName,
          marketingId,
          orderType,
          new: false,
          orderId,
          cashRegisterId: this.relevantCashRegister.id,
        },
      });
    },

    connectWebSocket() {
      try {
        this.socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
          reconnection: true, // Enable auto-reconnection
          reconnectionAttempts: 5, // Maximum number of reconnection attempts
          timeout: 10000, // Connection timeout in milliseconds
        });

        this.socket.on("connect_error", (error) => {
          this.messages.push(error.message);
          this.isConnected = false;
        });

        this.socket.on("disconnect", (reason) => {
          this.messages.push(reason);
          this.isConnected = false;
        });

        // Menerima pesan dari server
        this.socket.on("serverMessage", (data) => {
          this.handleWebSocketMessage(data);
          this.messages.push(data.message);
        });

        this.socket.on("welcome", (data) => {
          console.log("WELCOME: ", data);
          this.messages.push(data.message);
        });

        this.socket.on("new_items", (table) => {
          console.log("NEW_ITEMS: ", table);
          this.handleWebSocketMessage(table);
        });

        this.socket.on("update_items", (table) => {
          this.handleWebSocketMessage(table);
        });

        this.socket.on("delete_items", (table) => {
          this.handleWebSocketMessage(table);
        });

        this.socket.on("connect", () => {
          this.isConnected = true;
        });

        this.socket.on("error", (error) => {
          this.messages.push(error.message);
          this.isConnected = false;
        });

        this.handleReconnect();
      } catch (error) {
        this.isConnected = false;
      }
    },
    sendMessage() {
      // Kirim pesan ke server
      this.socket.emit("clientMessage", this.message);
      this.message = ""; // Reset input
    },
    handleWebSocketMessage(data) {
      this.isLoading = true;
      try {
        // Validasi data terlebih dahulu
        if (!data || !data.type) {
          return;
        }

        switch (data.type) {
          case "NEW_ITEMS":
            if (data.items && data.route == "table") {
              this.$store.commit("tables/addTable", data.items);
            }
            break;
          case "UPDATE_ITEMS":
            if (data.items && data.items.id && data.route == "table") {
              this.$store.commit("tables/updateTable", data.items);
            }
            break;
          case "DELETE_ITEMS":
            if (data.id && data.route == "table") {
              this.listTables = this.listTables.filter(
                (table) => String(table.id) !== String(data.id)
              );
            }
            break;
          default:
            console.warn("Unknown message type:", data.type);
        }
      } catch (error) {
        console.error("Error handling websocket message:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleReconnect() {
      if (this.socket) {
        this.socket.on("reconnect_attempt", (attemptNumber) => {
          console.log(`Reconnection attempt ${attemptNumber}`);
        });

        this.socket.on("reconnect", () => {
          console.log("Reconnected successfully");
          this.isConnected = true;
          // Mungkin perlu memuat ulang data
          this.socket.emit("requestInitialData");
        });

        this.socket.on("reconnect_failed", () => {
          console.log("Failed to reconnect");
          this.isConnected = false;
        });
      }
    },
  },
};
</script>
